import { call, fork, all, put, select, takeEvery, take } from "redux-saga/effects";
import { eventChannel } from "redux-saga";
import { questions as StoredSurvey } from "../reducers/survey";
import { auth as StoredUser } from "../reducers/user";
import * as Actions from "../actions";
import history from "../history";
import * as Api from "../api";

const { Action } = Actions;

function* onUserLanguageSwitched({ payload }) {
	yield put(Action(Actions.USER_LANGUAGE_SWITCH, payload));
}

function* onCreateUserWithEmailAndPassword({ payload }) {
	const auth = yield call(Api.createUserWithEmailAndPassword, payload);
	if (auth) {
		yield call(Api.userCreate, { uid: auth.uid, email: payload.email });
	}
	
}

function* onSignInWithEmailAndPassword({ payload }) {
	yield call(Api.signInWithEmailAndPassword, payload);
}

function* onGetOrders() {
	yield put(Action(Actions.ORDERS_FETCHING, true));
	const orders = yield call(Api.fetchOrders);
	if (orders) {
		yield put(Action(Actions.ORDERS_DOWNLOADED, orders));
	}
	yield put(Action(Actions.ORDERS_FETCHING, false));
}

function* onOrdersChecked({ payload }) {
	yield call(Api.checkedOrders, payload);
}

function* onSendPasswordResetEmail({ payload }) {
	yield call(Api.sendPasswordResetEmail, { email: payload.email });
}

function* onUserLanguage() {
	// let getLocale = "en-US";
	let getLocale = navigator.language || navigator.userLanguage || "en-US";
	let locale = getLocale.substr(0, 2);
	yield put(Action(Actions.USER_LANGUAGE, locale));
}

function* onChangeStep({ payload }) {
	yield call(Api.onChangeStep, payload);
}

function* onGetResult() {
	const result = yield call(Api.fetchResult);
	yield put(Action(Actions.SURVEY_RESULT_UPLOADED, result));
}

function* prepareSurvey() {
	const [survey, questions, answers] = yield all([
		call(Api.fetchSurvey),
		call(Api.fetchQuestions),
		call(Api.fetchAnswers)
	]);
	yield put(Action(Actions.SURVEY_PREPARED, { survey, questions, answers }));
}

function* onSurveyAnswer({ payload }) {
	const { id, variant: answer, options, uid } = payload;
	const survey = yield select(StoredSurvey);
	const questionId = survey[id].questId;
	const feedbackId = questionId[0];
	if (Array.isArray(questionId) && feedbackId !== 23) {
		yield all(questionId.map((questId, i) => call(Api.setResult, questId, {
			answer: (answer && answer[i]) || null,
			options: (options && options[i]) || null
		})));
	} else if (feedbackId === 23) {
		yield call(Api.surveyFeedback, { uid, feedback: options[0] || null });
	}
	else {
		yield call(Api.setResult, questionId, { answer: answer, options });
	}
	if (survey[id].next === -1) {
		yield call(Api.surveyPassed, uid);
		yield put(Action(Actions.USER_SURVEY_PASSED, uid));
		history.push(`/survey/finish`);
	}
}

function* onAuthUpdate() {
	const listener = eventChannel(Api.authUpdate());
	while (true) {
		const { auth } = yield take(listener);
		yield put(Action(Actions.AUTH_UPDATED, { auth }));
		yield call(updateUserData);
		yield put(Action(Actions.USER_FETCHING, false));
	}
}

function* onSignOut() {
	Api.signOut();
}

function* onUserBuy({ payload }) {
	yield call(Api.userBuy, payload);
}

function* onSurveyPassed({ payload }) {
	yield call(Api.surveyPassed, payload);
}

function* onUserDownload({ payload }) {
	if (payload) {
		yield put(Action(Actions.USER_FETCHING, true));
		const user = yield call(Api.fetchUser, payload);
		if (user) {
			yield put(Action(Actions.USER_FETCH, user));
		}
		yield put(Action(Actions.USER_FETCHING, false));
	}
}

function* updateUserData() {
	let auth = yield select(StoredUser);
	if (auth) {
		yield put(Action(Actions.USER_FETCHING, true));
		const user = yield call(Api.fetchUser, auth.uid);
		if (user) {
			yield put(Action(Actions.USER_FETCH, user));
		}
		yield put(Action(Actions.USER_FETCHING, false));
	}
}

function* initData() {
	yield call(Api.init);
	yield call(onUserLanguage);
	yield call(prepareSurvey);
}

function* auth() {
	yield fork(onAuthUpdate);
	yield takeEvery(Actions.USER_BUY, onUserBuy);
	yield takeEvery(Actions.USER_SURVEY_PASSED, onSurveyPassed);
}

function* init() {
	yield fork(initData);
	yield takeEvery(Actions.SURVEY_ANSWERED, onSurveyAnswer);
	yield takeEvery(Actions.USER_LANGUAGE_SWITCHED, onUserLanguageSwitched);
	yield takeEvery(Actions.ORDERS_UPLOADED, onGetOrders);
	yield takeEvery(Actions.ORDERS_CHECKED, onOrdersChecked);
	yield takeEvery(Actions.CREATE_USER_WITH_EMAIL_AND_PASSWORD, onCreateUserWithEmailAndPassword);
	yield takeEvery(Actions.SIGN_IN_USER_WITH_EMAIL_AND_PASSWORD, onSignInWithEmailAndPassword);
	yield takeEvery(Actions.SEND_PASSWORD_RESET_EMAIL, onSendPasswordResetEmail);
	yield takeEvery(Actions.SURVEY_UPLOAD_RESULT, onGetResult);
	yield takeEvery(Actions.USER_GET_BY_ID, onUserDownload);
	yield takeEvery(Actions.USER_SIGN_OUT, onSignOut);
	yield takeEvery(Actions.SURVEY_CHANGE_STEP, onChangeStep);
}

export default function* root() {
	yield fork(init);
	yield fork(auth);
}





// WEBPACK FOOTER //
// ./src/sagas/index.js